import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiClient } from '../../api';
import { createInquiry } from '../../utils/home-util';

const initialState = {
  whatsappNumber: '9714859797',
  whatsappEnabled: true,
  inquiryEnabled: true,
  inquiryAction: '/inquiry.php',
  captchaSrc: '/captcha.php',
  status: 'idle',
  submitting: false,
  submitSuccess: false,
  submitError: null,
};

export const submitInquiry = createAsyncThunk('submitInquiry', async (inquiryData) => {
  const data = await createInquiry(inquiryData);
  return data;
});

const floatingSlice = createSlice({
  name: 'floating',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitInquiry.pending, (state) => {
        state.submitting = true;
        state.submitSuccess = false;
        state.submitError = null;
      })
      .addCase(submitInquiry.fulfilled, (state) => {
        state.submitting = false;
        state.submitSuccess = true;
        state.submitError = null;
      })
      .addCase(submitInquiry.rejected, (state, action) => {
        state.submitting = false;
        state.submitSuccess = false;
        state.submitError = action.error.message;
      });
  },
});

export default floatingSlice.reducer;

